import {
	challengesCollection,
	featuredUsersCollection,
	usersCollection,
} from '../../config/firebase';

let state = {
	user: {},
	users: [],
	featuredUsers: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	user: state => state.user,
	fusers: state => state.users,
	featuredUser: state => state.featuredUsers,
	userLoading: state => state.loading,
	userNotification: state => state.notification,
};
let actions = {
	async getUser({ commit }, payload) {
		commit('setUserLoading', true);
		let userSnap = await featuredUsersCollection.doc(payload).get();
		let userData = userSnap.data();
		commit('setUserData', {id:payload, ...userData});
		commit('setUserLoading', false);
	},
	async getUsers({ commit }, payload) {
		commit('setUserLoading', true);
		featuredUsersCollection.onSnapshot(snapshot => {
			let users = [];
			for (let doc of snapshot.docs) {
				usersCollection
					.doc(doc.data().user_id)
					.get()
					.then(userSnap => {
						challengesCollection
							.doc(doc.data().challenge_id)
							.get()
							.then(challengeSnap => {
								let data = challengeSnap.data();
								delete data['genre'];
								users.push({
									id: doc.id,
									...doc.data(),
									...userSnap.data(),
									...data,
								});
							});
					});
			}
			commit('setUsersData', users);
			commit('setUserLoading', false);
		});
	},
	async getFeaturedUsers({ commit }) {
		commit('setUserLoading', true);
		featuredUsersCollection
			.where('isActive', '==', true)
			.onSnapshot(snapshot => {
				let users = [];
				for (let doc of snapshot.docs) {
					usersCollection
						.doc(doc.data().user_id)
						.get()
						.then(userSnap => {
							challengesCollection
								.doc(doc.data().challenge_id)
								.get()
								.then(challengeSnap => {
									let data = challengeSnap.data();
									delete data["genre"];
									users.push({
										id: doc.id,
										...doc.data(),
										...userSnap.data(),
										...data,
									});
								});
						});
				}

				commit('setFeaturedUserData', users);
				commit('setUserLoading', false);
			});
	},
};
let mutations = {
	setUserData(state, payload) {
		state.user = payload;
	},
	setUsersData(state, payload) {
		state.users = payload;
	},
	setFeaturedUserData(state, payload) {
		state.featuredUsers = payload;
	},
	setUserLoading(state, payload) {
		state.loading = payload;
	},
	setUsersNotification(state, payload) {
		let { notification } = state;
		notification.message = payload.message;
		notification.type = payload.type;
		state.notification = notification;
		window.setTimeout(() => {
			let obj = { message: '', type: '' };
			state.notification = obj;
		}, 5000);
	},
};
export default { state, getters, actions, mutations };
